/* eslint-disable react-refresh/only-export-components */
import { Tooltip as ReactTooltip } from "react-tooltip";
import React from "react";

type TooltipValue = Partial<
  React.ComponentPropsWithoutRef<typeof ReactTooltip>
>;
export const TooltipContext = React.createContext<TooltipValue>(
  undefined as unknown as TooltipValue,
);

export function useTooltip() {
  return React.useContext(TooltipContext);
}

export function useTooltipId() {
  return React.useContext(TooltipContext)?.id;
}

export type TooltipProps = {
  "data-tooltip-id": string | undefined;
};

export function useTooltipProps(): TooltipProps {
  const tooltipId = useTooltipId();
  return React.useMemo(() => ({ "data-tooltip-id": tooltipId }), [tooltipId]);
}

export function TooltipContent(
  props: React.ComponentPropsWithoutRef<typeof ReactTooltip>,
) {
  const _props = useTooltip();
  return (
    <ReactTooltip
      {..._props}
      {...props}
      className={cn(
        "z-[9999] max-w-sm rounded-md bg-popover px-3 py-1.5 text-sm text-popover-foreground shadow-md",
        props.className,
      )}
    />
  );
}

export const TooltipProvider = ({
  children,
  id: __id,
  ...props
}: TooltipValue & {
  children?: React.ReactNode;
}) => {
  const _id = React.useId();
  const id = __id ?? _id;
  return (
    <TooltipContext.Provider value={{ id, ...props }}>
      {children}
    </TooltipContext.Provider>
  );
};

import * as Tooltip_ from "@radix-ui/react-tooltip";
import { cn } from "@/lib/utils";

export function Tooltip({ children, content, className }) {
  return (
    <Tooltip_.Provider>
      <Tooltip_.Root>
        <Tooltip_.Trigger asChild>{children}</Tooltip_.Trigger>
        <Tooltip_.Portal>
          <Tooltip_.Content
            className={cn("TooltipContent", className)}
            sideOffset={5}
            align="start"
          >
            {content}
            <Tooltip_.Arrow className="TooltipArrow" />
          </Tooltip_.Content>
        </Tooltip_.Portal>
      </Tooltip_.Root>
    </Tooltip_.Provider>
  );
}
